import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Dropdown, DropdownItem} from '@homeaway/react-dropdown';
import triggerEdapEvent from '../../utils/edap';

class CurrencySelector extends Component {
    static propTypes = {
        currencyList: PropTypes.arrayOf(
            PropTypes.shape({
                code: PropTypes.string,
                symbol: PropTypes.string,
                name: PropTypes.string
            })
        ),
        title: PropTypes.string,
        disclaimer: PropTypes.string,
        code: PropTypes.string,
        onChange: PropTypes.func
    }

    static defaultProps = {
        title: 'Currency',
        disclaimer: 'Please note: You will still be charged in the owner\'s currency.',
        currency: {code: 'USD', symbol: 'US$', name: 'US Dollar'},
        currencyList: [],
        onChange: () => {}
    }

    /* istanbul ignore next */
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event, currency) {
        event.preventDefault();
        const currencyCodeSelected = currency.code;
        this.props.onChange(currencyCodeSelected);
    }

    handleDropdownShow() {
        triggerEdapEvent({
            eventaction: 'display currency dropdown clicked'
        });
    }

    render() {
        const {title, currency, disclaimer, currencyList} = this.props;
        return (
            <div className="currency-selector preference-selector form-group">
                <div className="preference-selector__title">{title}</div>
                <Dropdown
                    srOnlyLabel
                    label="Currency Selector"
                    buttonChildren={
                        <div className="preference-selector__option media">
                            <div className="option-currency-code media-left media-middle">{currency.code}</div>
                            <div className="option-currency-name media-body">{`${currency.name} (${currency.symbol})`}</div>
                        </div>
                    }
                    id="currency-selector"
                    name="currency-selector"
                    onDropdownShow={this.handleDropdownShow}
                >
                    {currencyList.map((c) => {
                        return (
                            <DropdownItem
                                link="#"
                                text={
                                    <div className="preference-selector__option media">
                                        <div className="option-currency-code media-left media-middle">{c.code}</div>
                                        <div className="option-currency-name media-body">{c.name}</div>
                                    </div>
                                }
                                key={c.code}
                                onClick={(event) => this.handleChange(event, c)} // eslint-disable-line react/jsx-no-bind
                            />
                        );
                    })}
                </Dropdown>
                <p className="help-block preference-selector__disclaimer">{disclaimer}</p>
            </div>
        );
    }
}

export default CurrencySelector;
